import React, { useState } from 'react'

import { arrayOf, object } from 'prop-types'
import Container from 'components/atoms/Container'
import SectionTitle from 'components/atoms/SectionTitle'
import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import TestimonyCard from 'components/molecules/TestimonyCard'

import config from 'config'

const { assets_url: assetsUrl } = config

const SchoolTestimonies = ({ testimonies }) => {
  const [showTestimonies, setShowTestimonies] = useState(false)
  const toggleShowMore = () => setShowTestimonies(!showTestimonies)
  return (
    <div className="school-testimonies" id="testimonies">
      <Container>
        <SectionTitle title="Testimoni" />
      </Container>
      <ThumbnailSlider slidesToShow={2}>
        {
          testimonies.map((testimony, idx) => {
            const testimonyProp = {
              name: testimony.student_name,
              img: testimony.student_photo_url,
              imgAlt: testimony.student_name,
              testimony: testimony.description,
              schoolName: testimony.school_name,
              year: testimony.year,
              majorName: testimony.study_field_name,
              direction: 'row',
            }
            return (<TestimonyCard
              {...testimonyProp}
              key={`sch-testimony-${idx}`}
              onClick={() => toggleShowMore()}
              showMore={showTestimonies}
            />)
          })
        }
      </ThumbnailSlider>
      <style jsx>
        {`
          .school-testimonies {
            padding-top: 80px;
            background: url(${assetsUrl}/assets/img/school_testimonies_bg/rectangle.png) right top no-repeat, linear-gradient(to top left, #fff 0%, #fff 50%, #f6f7fa 50%, #f6f7fa 100%) no-repeat;
            background-size: auto, 100% 90%;
            @media screen and @media(min-width: 768px) {
              padding-top: 40px;
            }
            :global(.ThumbnailSlider) {
              overflow: unset;
              margin: 20px 0 0 0;
            }
            :global(.slick-slider) {
              overflow: hidden;
            }
            :global(.slick-track) {
              display: flex;
              max-height: none;
            }
            :global(.slick-slide) {
              height: inherit;
            }
            :global(.slick-slide > div) {
              height: 100%;
            }
            :global(.slick-arrow) {
              top: 50%;
            }
            :global(.testimony) {
              padding: 0 10px;
              height: inherit;
            }
            :global(.testimony__card) {
              box-shadow: 0 2px 8px 0 #ebeef3;
            }
            :global(.testimony-identity__name) {
              color: #485c77;
            }
            :global(.testimony-identity__school) {
              color: #8fb0d4;
            }
            :global(.testimony-identity__major) {
              color: #8fb0d4;
            }
          }
        `}
      </style>
    </div>
  )
}

SchoolTestimonies.propTypes = {
  testimonies: arrayOf(object),
}

export default SchoolTestimonies
